// src/api/matches.js
import { apiCall } from "./client";

// ---- Matches (list, details) ----
export const getMatches = () => apiCall("/api/matches");
export const getOpenMatches = async () => {
  const pageSize = 100;
  const matches = [];

  for (let page = 1; ; page += 1) {
    const batch = await apiCall(
      `/api/matches?open_only=true&page=${page}&page_size=${pageSize}`
    );
    if (!Array.isArray(batch)) {
      throw new Error("Kunde inte läsa listan med skapade protokoll");
    }
    matches.push(...batch);
    if (batch.length < pageSize) break;
  }

  return matches;
};
const buildPagedMatchesQuery = ({ page = 1, pageSize = 5, sortKey, sortDir }) => {
  const params = new URLSearchParams({
    page: String(page),
    page_size: String(pageSize),
    sort_key: sortKey,
    sort_dir: sortDir,
  });
  return params.toString();
};
export const getOpenMatchesPaged = (params) =>
  apiCall(`/api/matches/paged?${buildPagedMatchesQuery(params)}`);
export const getMatchesSummary = (recentLimit = 10) =>
  apiCall(`/api/matches/summary?recent_limit=${encodeURIComponent(String(recentLimit))}`);

export const getMatchById = (id) => apiCall(`/api/matches/${id}`);

export const deleteMatch = (id) =>
  apiCall(`/api/matches/${id}`, { method: "DELETE", body: JSON.stringify({}) });

export const deleteUserMatch = (userMatchId) =>
  apiCall(`/api/user-matches/${userMatchId}`, { method: "DELETE", body: JSON.stringify({}) });

export const deleteUserMatchCascade = (userMatchId) =>
  apiCall(`/api/user-matches/${userMatchId}`, { method: "DELETE", body: JSON.stringify({}) });

export const restoreUserMatch = (userMatchId) =>
  apiCall(`/api/user-matches/${userMatchId}/restore`, { method: "POST" });

// ---- Create from official / list official ----
export const getOfficialMatches = ({ includeUsed = false } = {}) => {
  const qs = includeUsed ? "?include_used=true" : "";
  return apiCall(`/api/official-matches${qs}`);
};

export const createFromOfficial = (official_match_id) =>
  apiCall("/api/matches/from-official", {
    method: "POST",
    body: JSON.stringify({ official_match_id }),
  });

export const refreshMatchLineup = (matchId) =>
  apiCall(`/api/matches/${matchId}/refresh-lineup`, {
    method: "POST",
  });

export const restartMatchLineup = (matchId) =>
  apiCall(`/api/matches/${matchId}/restart-lineup`, {
    method: "POST",
  });

export const resetMatchToInitialLineup = (matchId, team) =>
  apiCall(`/api/matches/${matchId}/reset-initial-lineup`, {
    method: "POST",
    body: JSON.stringify({ team }),
  });

export const updateManualMatchLineup = (matchId, lineups) =>
  apiCall(`/api/matches/${matchId}/manual-lineup`, {
    method: "PUT",
    body: JSON.stringify({ lineups }),
  });

// ---- Confirm match ----
export const confirmMatch = (id, payload = {}) =>
  apiCall(`/api/matches/${id}/confirm`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });

// ---- Heat results & riders ----
export const clearHeatResults = (matchId, heatNumber) =>
  apiCall(`/api/matches/${matchId}/heat/${heatNumber}/result`, {
    method: "PUT",
    body: JSON.stringify({ results: [] }),
  });

export const putHeatResults = (matchId, heatNumber, results) =>
  apiCall(`/api/matches/${matchId}/heat/${heatNumber}/result`, {
    method: "PUT",
    body: JSON.stringify({ results }),
  });

// export const updateHeatRiders = (matchId, heatNumber, assignments) => {
//   const token = localStorage.getItem("speedway_token");
//   return fetch(
//     `${API_BASE_URL}/api/matches/${matchId}/heat/${heatNumber}/riders`,
//     {
//       method: "PUT",
//       headers: {
//         "Content-Type": "application/json",
//         ...(token && { Authorization: `Bearer ${token}` }),
//       },
//       body: JSON.stringify(assignments),
//     }
//   ).then(async (res) => {
//     if (!res.ok) {
//       const data = await res.json().catch(() => ({}));
//       throw new Error(data.detail || "Kunde inte uppdatera heat-uppställningen");
//     }
//     return res.json();
//   });
// };

// export const updateHeatRiders = (matchId, heatNumber, assignments) =>
//   apiCall(`/api/matches/${matchId}/heat/${heatNumber}/riders`, {
//     method: "PUT",
//     body: JSON.stringify(assignments),
//   });

export const updateHeatRiders = (matchId, heatNumber, assignments, { rr = false } = {}) =>
  apiCall(`/api/matches/${matchId}/heat/${heatNumber}/riders${rr ? '?rr=true' : ''}`, {
    method: "PUT",
    body: JSON.stringify(assignments),
  });


export const saveHeat = (matchId, heatNumber, payload) =>
  apiCall(`/api/matches/${matchId}/heat/${heatNumber}/save`, {
    method: "POST",
    body: JSON.stringify(payload),
  });

// ---- User matches (My Matches) ----
export const getUserMatches = () => apiCall("/api/user/matches");
export const getUserMatchesPaged = (params) =>
  apiCall(`/api/user/matches/paged?${buildPagedMatchesQuery(params)}`);
export const getUserMatchesSummary = (recentLimit = 5) =>
  apiCall(`/api/user/matches/summary?recent_limit=${encodeURIComponent(String(recentLimit))}`);

// export const getUserMatchById = (userMatchId) =>
//   apiCall(`/api/user/matches/${userMatchId}`);

export function getUserMatchById(userMatchId) {
  return apiCall(`/api/user/matches/${userMatchId}`);
}

export const resolveUserMatch = (userMatchId, action) =>
  apiCall(`/api/user/matches/${userMatchId}/resolve`, {
    method: "PUT",
    body: JSON.stringify({ action }),
  });

// export const getOfficialMatchById = (officialId) =>
//   apiCall(`/api/official-matches/${officialId}`);

export function getOfficialMatchById(officialId) {
  return apiCall(`/api/official-matches/${officialId}`);
}

export const updateOfficialMatchLineup = (officialId, lineups) =>
  apiCall(`/api/official-matches/${officialId}/lineup`, {
    method: "PUT",
    body: JSON.stringify({ lineups }),
  });

export const clearOfficialMatchLineup = (officialId) =>
  apiCall(`/api/official-matches/${officialId}/lineup`, {
    method: "DELETE",
  });

export const resetOfficialMatchLineupState = (officialId) =>
  apiCall(`/api/official-matches/${officialId}/lineup/reset-state`, {
    method: "POST",
  });
